"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Separator = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _SeparativeLine = require("../../ui/SeparativeLine");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Separator = (0, _styledComponents.default)(_SeparativeLine.SeparativeLine)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  margin: 50px 0 23px;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondaryShade2 + 40;
});
exports.Separator = Separator;